import { useState } from 'react'
import { Link } from 'react-router-dom'

import { AuthScaffold } from './AuthScaffold'
import { FxAlert, FxButton, FxTextField } from '@/components/fx'
import { ApiError, authApi } from '@/lib/api'

/**
 * "Passwort vergessen?" — the screen the sign-in page has been linking to
 * since before it existed.
 *
 * The confirmation never says whether the address is registered. The gateway
 * is careful about this ("if an account with that email exists…") and a
 * screen that said "wir haben dir eine E-Mail geschickt" for a known address
 * and something else for an unknown one would hand that care straight back.
 */
export function PasswordResetRequestPage() {
  const [email, setEmail] = useState('')
  const [sent, setSent] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  const backToLogin = (
    <p className="text-small">
      <Link className="text-primary-text" to="/login">
        Zurück zur Anmeldung
      </Link>
    </p>
  )

  if (sent) {
    return (
      <AuthScaffold title="E-Mail unterwegs" footer={backToLogin}>
        <FxAlert tone="success" className="text-left">
          Falls es ein Konto mit dieser Adresse gibt, haben wir einen Link zum Zurücksetzen
          geschickt. Der Link gilt nur für kurze Zeit.
        </FxAlert>
      </AuthScaffold>
    )
  }

  return (
    <AuthScaffold
      title="Passwort zurücksetzen"
      subtitle="Gib deine E-Mail-Adresse ein. Wir senden dir einen Link, mit dem du ein neues Passwort setzen kannst."
      footer={backToLogin}
    >
      {error && (
        <FxAlert tone="danger" className="text-left">
          {error}
        </FxAlert>
      )}
      <form
        className="flex flex-col gap-7 text-left"
        onSubmit={(event) => {
          event.preventDefault()
          setBusy(true)
          setError(null)
          void authApi
            .requestPasswordReset(email.trim())
            .then(() => setSent(true))
            .catch((cause) => setError(ApiError.from(cause).message))
            .finally(() => setBusy(false))
        }}
      >
        <div>
          <label htmlFor="reset-email" className="sr-only">
            E-Mail
          </label>
          <FxTextField
            id="reset-email"
            onWhite
            placeholder="E-Mail"
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </div>
        <FxButton type="submit" block disabled={busy}>
          {busy ? 'Link wird gesendet …' : 'Link senden'}
        </FxButton>
      </form>
    </AuthScaffold>
  )
}
